import {
  PaymentDto,
  WebPaymentResponseDto,
  OrderPaymentDto,
  PaymentReferenceType,
  BankSource
} from '@up/data';
import { IsBoolean, IsNumber, IsOptional, IsString } from 'class-validator';

export class StripePaymentResponseDto {
  @IsBoolean()
  success: boolean;

  @IsOptional()
  paymentReferenceType?: PaymentReferenceType;

  @IsOptional()
  payment?: PaymentDto | WebPaymentResponseDto | OrderPaymentDto;

  @IsOptional()
  @IsString()
  message?: string;

  @IsString()
  @IsOptional()
  source?: BankSource;

  @IsString()
  @IsOptional()
  paymentIntentId?: string;

  @IsString()
  @IsOptional()
  clientSecret?: string;

  @IsString()
  @IsOptional()
  status?: string;

  @IsBoolean()
  @IsOptional()
  wasAlreadyPaid?: boolean;

  @IsString()
  @IsOptional()
  currency?: string;

  @IsBoolean()
  @IsOptional()
  notAStripePayment?: boolean;

  @IsNumber()
  @IsOptional()
  orderId?: number;

  @IsString()
  @IsOptional()
  customer?: string;

  @IsBoolean()
  @IsOptional()
  storeCard?: boolean;

  @IsNumber()
  @IsOptional()
  paymentMethodId?: number;

  @IsNumber()
  @IsOptional()
  customerId?: number;

  @IsString()
  @IsOptional()
  paymentMethod?: string;

  @IsNumber()
  @IsOptional()
  processingFee?: number;

  @IsNumber()
  @IsOptional()
  totalFeeThatUpCoWillReceive?: number;

  @IsNumber()
  @IsOptional()
  baseFeeThatUpCoWillReceive?: number;

  @IsNumber()
  @IsOptional()
  vatFeeThatUpCoWillReceive?: number;

  @IsNumber()
  @IsOptional()
  amountToBeSentToBusinessEntity?: number;

  @IsBoolean()
  @IsOptional()
  stripeConnectWasUsed?: boolean;

  @IsNumber()
  @IsOptional()
  stripeConnectFeePercentage?: number;

  @IsNumber()
  @IsOptional()
  stripeConnectFeeAmount?: number;

  @IsString()
  @IsOptional()
  stripeConnectAccountId?: string;

  @IsNumber()
  @IsOptional()
  merchantId?: number;

  @IsNumber()
  @IsOptional()
  processingFeeAmount?: number;
}
